import React from 'react'

export const ButtonInlineUnstyled = ({
  labelFirst = false,
  icon,
  ...props
}) => (
  <div className={props.className} onClick={props.onClickHandler}>
    {labelFirst ? (
      <div>
        {props.label}
        {icon}
      </div>
    ) : (
      <div>
        {icon}
        {props.label}
      </div>
    )}
  </div>
)
